import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormalizeCommentComponent } from './formalize-comment.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FormalizeCommentComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [FormalizeCommentComponent],
  entryComponents: [FormalizeCommentComponent]
})
export class FormalizeCommentModule { }
